import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import styles from "./ekyc.module.scss";
import { APIConstant } from "services/api-constant";
import Images from "assets/Images";
import ReportsInterviewDataList from "./dashboardTable";
import MyBarChart from "./charts/barchart";
import OnHoldByTechLine from "./charts/lineChart";
import QuestionsByTechPie from "./charts/totalQuestionsChart";
import InterviewsByTechHorizontalBar from "./charts/horizontalBarchart";

import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file

const EkycDashboard = ({ token }) => {
 const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true); // Loader state
 
   const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [open, setOpen] = useState(false);
  const ref = useRef();

  // Close picker when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);
        const res = await axios.get(APIConstant.getReports, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSummary(res.data.summary);
        // setScoreStats(res.data.score_stats);
        setQuestionDistribution(res.data.question_distribution);
      } catch (error) {
        console.error("Failed to fetch reports:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, [token]);

  if (loading) {
    return (
      <div className={styles.reportsContainer}>
        <h2 className={styles.pageHeading}>eKYC Dashboard</h2>
        <div className="flex justify-center items-center h-64">
          <p className={`text-gray-500 text-lg ${styles.reportLoader}`}>
            <img src={Images.SPINNER} width="80" alt="Loading..."/>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.reportsContainer}>
      

      <div className={styles.pageHeader}>
        <h2 className={styles.pageHeading}>eKYC Dashboard</h2>
        <div className={styles.datePicker} ref={ref}>
          {/* Input box that triggers dropdown */}
          <img src={Images.CALENDAR} alt="Picker" width="16"
            style={{
              position: 'absolute',
              right: '5px',
              top: '4px'
            }}
          />
          <input
            readOnly
            value={`${state[0].startDate.toLocaleDateString()} - ${state[0].endDate.toLocaleDateString()}`}
            onClick={() => setOpen(!open)}
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          />

          {/* Dropdown calendar */}
          {open && (
            <div
              style={{
                right: 0,
                position: "absolute",
                top: "110%",
                zIndex: 1000,
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "4px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              <DateRange
                editableDateInputs={true}
                onChange={(item) => setState([item.selection])}
                moveRangeOnFirstSelection={false}
                ranges={state}
              />
            </div>
          )}
        </div>
      </div>

      {/* Summary Cards */}
      <div className={styles.reportHeader}>
        <div className={`bg-white shadow rounded p-3 text-center ${styles.b1}`}>
          <p className={styles.textValue}>20000</p>
          <p className={styles.label}>Total Users</p>
          {/* <p className={styles.textValue}>{summary.users}</p> */}
          <img src={Images.USERS_COUNT} alt="Users" width="26" />
        </div>
        <div className={`bg-white shadow rounded p-3 text-center ${styles.b2}`}>
          <p className={styles.textValue}>1500</p>
          <p className={styles.label}>Total Interviews</p>
          {/* <p className={styles.textValue}>{summary.interviews}</p> */}
          <img src={Images.INTERVIEWS_COUNT} alt="Interviews" width="26" />
        </div>
        <div className={`bg-white shadow rounded p-3 text-center ${styles.b3}`}>
          <p className={styles.textValue}>200</p>
          <p className={styles.label}>Questions</p>
          {/* <p className={styles.textValue}>{summary.questions}</p> */}
          <img src={Images.QUESTIONS_COUNT} alt="Questions" width="26" />
        </div>
        <div className={`bg-white shadow rounded p-3 text-center ${styles.b4}`}>
          <p className={styles.textValue}>75</p>
          <p className={styles.label}>Average Score</p>
          {/* <p className={styles.textValue}>{summary.avg_score}</p> */}
          <img src={Images.AVERAGE_SCORES} alt="Score" width="26" />
        </div>
      </div>

    <div className={styles.chartContainer}>
      {/* Score Trends */}
      <div className={`${styles.chartCard} bg-white  rounded p-6 mb-6`}>
        <h3 className="text-xl font-semibold text-gray-700 mb-4">Interview scheduled by Technology</h3>
        <InterviewsByTechHorizontalBar />
      </div>

      {/* Question Distribution */}
      <div className={`${styles.chartCard} bg-white  rounded p-6`}>
        <h3 className="text-xl font-semibold text-gray-700 mb-4">Candidates Slected by Technology</h3>
        <MyBarChart />
      </div>

      {/* Performance by Category */}
      <div className={`${styles.chartCard} bg-white  rounded p-6`}>
        <h3 className="text-xl font-semibold text-gray-700 mb-4">On Hold by Technology</h3>
        <OnHoldByTechLine />
      </div>

      <div className={`${styles.chartCard} bg-white  rounded p-6 mb-6`}>
        <h3 className="text-xl font-semibold text-gray-700 mb-4">Total questions based on technology</h3>
        <QuestionsByTechPie />
      </div>
      </div>

      <div className={styles.interviewsGridContainer}>
          <ReportsInterviewDataList />
      </div>
    </div>
  );
};

export default EkycDashboard;
